import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getProducts} from 'api/requests';
import {IProductsRequest, IProductsResponse} from 'types';

export const useProduct = (queryKey: QueryKey, data: IProductsRequest, options: UseQueryOptions<IProductsResponse>) => {
  return useQuery<IProductsResponse>({
    queryKey,
    queryFn: () => getProducts(data),
    ...options,
  });
};
